import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from './Pages/Home/Home.jsx';
import Registration from './Pages/Customers/Registration/Registration';
import LoginPage from './Pages/Authentication/Login/LoginPage.jsx';
import VendorMasterForm from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/VendorMasterForm.jsx';
import VendorApporoved from './Pages/CompanyAdmin/VendorsDetails/VendorApproved/VendorApporoved.jsx';
import Admin from './Pages/CompanyAdmin/AdminHome/SideBar/Admin.jsx';
import CustomerMasterForm from './Pages/CompanyAdmin/CustomersDetails/CustomerMaster/CustomerMaster.jsx';
import CustomerApproved from './Pages/CompanyAdmin/CustomersDetails/CustomerApporoved/CustomerApproved.jsx';
import VehicleClaimRegistration from './Pages/CompanyAdmin/VehicleClaimRegistration/VehicleClaimRegistration.jsx';
import ViewVehicleInfo from './Pages/CompanyAdmin/ViewVehicleInfo/ViewVehicleInfo.jsx';
import VendorMasterEdit from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/VendorMasterEdit.jsx';
import CustomerMasterEdit from './Pages/CompanyAdmin/CustomersDetails/CustomerMaster/CustomerMasterEdit.jsx';
import VehicleClaimEdit from './Pages/CompanyAdmin/VehicleClaimRegistration/VehicleClaimEdit.jsx';
import VendorMasterViewOnly from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/VendorMasterViewOnly.jsx';
import ImageUpload from './Component/CompanyAdmin/ImageUpload/ImageUpload.jsx';
import User from './Pages/CompanyAdmin/AdminHome/User.jsx';
import AccidentVehicle from './Pages/CompanyAdmin/AccidentVehicle/AccidentVehicle.jsx';
import Advocate from './Pages/CompanyAdmin/VendorResponse/Advocate.jsx';
import Mechanic from './Pages/CompanyAdmin/VendorResponse/Mechanic.jsx';
import CraneHydra from './Pages/CompanyAdmin/VendorResponse/CraneHydra.jsx';
import AddedDataByCrane from './Pages/CompanyAdmin/VendorResponse/AddedDataByCrane.jsx';
import AccidentVehicleRegUpdate from './Pages/CompanyAdmin/AccidentVehicle/AccidentVehicleRegUpdate.jsx';
import VendorResponse from './Pages/CompanyAdmin/VendorResponse/VendorsResponse.jsx';
import Workshop from './Pages/CompanyAdmin/VendorResponse/Workshop.jsx';
import DailyWorkshop from './Pages/CompanyAdmin/VendorResponse/DailyWorkshop.jsx';
import EmployeeForm from './Pages/CompanyAdmin/Employees/EmployeeForm.jsx';
import EmployeeApproved from './Pages/CompanyAdmin/Employees/EmployeeApproved.jsx';
import EmployeeFormEdit from './Pages/CompanyAdmin/Employees/EmployeeFormEdit.jsx';
import Visitors from './Pages/CompanyAdmin/Visitors/Visitors.jsx';
import Payment from './Pages/Customers/PaymentPage/Payment.jsx';
import VendorPayment from './Pages/Customers/PaymentPage/VendorPayment.jsx';
import MechanicDashboard from './Pages/CompanyAdmin/VendorResponse/MechanicDashboard.jsx';
import NotFoundPage from './Component/CompanyAdmin/CompanyAdminHome/NotFound.jsx';
import CustomerEnquiry from './Pages/CompanyAdmin/Enquiry/CustomerEnquiry.jsx';
import Challan from './Pages/CompanyAdmin/Challan/challan.jsx';

import CreatePassword from './Pages/Home/CreatePassword/CreatePassword.jsx';
// import Administration from './Component/EmployeeDashboard/Administration';
import Administration from './Pages/CompanyAdmin/Administration.jsx';
import Salesteam from './Pages/CompanyAdmin/Administration.jsx';
import DummyDashboard from './Pages/CompanyAdmin/AdminHome/Dashboard/DummyDashboard.jsx';
import { Provider } from 'react-redux';
// import store from './Pages/Authentication/Login/store.js/Component/Login/store';
import store from './Pages/Authentication/Login/store.js';
import ProtectedRoute from './Pages/Authentication/Login/ProtectedRoute.js';
import SidebarWithSubmenus from './Component/CompanyAdmin/CompanyAdminHome/CustomerAdminDashboard/SidebarWithSubmenus.jsx';
import Registrations from './Pages/Authentication/Registrations/Registrations.jsx';
import ImageViewer from './Pages/Home/Scrap/ImageViewer.jsx';
import ImageDetails from './Pages/Home/Scrap/ImageDetails.jsx';
import Blogs from './Pages/Home/Blogs/Blogs.jsx';
import Sidebar from './Pages/Home/Sidebar.jsx';
// import ProductRegister from './Pages/Scrap/ProductRegsiter';
import ProductRegister from './Pages/Home/Scrap/ProductRegsiter.jsx';
import ProductDetailsSeller from './Pages/Home/Scrap/ProductDetailsSeller.jsx';
import CaseFirstCard from './Component/Vendors/FirstAppearComponent/CaseFirstCard/CaseFirstCard.jsx';
import SuccessIcon from './Component/Vendors/FirstAppearComponent/CaseFirstCard/SuccessIcon.jsx';
import ErrorIcon from './Component/Vendors/FirstAppearComponent/CaseFirstCard/ErrorIcon.jsx';
import CompletePayment from './Component/CompanyAdmin/Charts/CompletePayment.jsx';
import FirstPage from './Pages/Customers/FirstPageDesigns/FirstPage.jsx';
import CraneFirstPage from './Pages/Customers/VendorResponsesCustomer/CraneFirstPage.jsx';
import UserSideBar from './Component/CompanyAdmin/UserSideBar.jsx'
import SelectLocationOnMap from './Pages/Customers/Map/SelectLocationOnMap.jsx';
import CraneUserLanding from './Pages/Vendors/CraneUserLanding.jsx';
import MapForVendorDistance from './Pages/Customers/Map/MapForVendorDistance.jsx';
import AllVehicles from './Pages/Customers/AllVehicles/AllVehicles.jsx';
import AllAccidentVehiclesUser from './Pages/Customers/VendorResponsesCustomer/AllAccidentVehiclesUser.jsx';
import HistoryPageUser from './Pages/Customers/VendorResponsesCustomer/HistoryPageUser.jsx';
import UserProfileFirst from './Pages/Customers/UserProfile/UserProfileFIrst.jsx';
import UserProfileDetails from './Pages/Customers/UserProfile/UserProfileDetails.jsx';
import KycDocuments from './Pages/Customers/UserProfile/KycDocuments.jsx';
import CraneUserDashboard from './Pages/Vendors/VendorAdmin/CraneUserDashboard.jsx';
import CraneOrders from './Pages/Vendors/VendorAdmin/CraneOrders/CraneOrders.jsx';
import CraneVehicleData from './Pages/Vendors/VendorAdmin/CraneVehicleData.jsx';
import NewAccidentVehicle from './Component/Customers/NewAccidentVehicle/NewAccidentVehicle.jsx';
import AddNewVehicle from './Pages/Customers/Registration/AddNewVehicle.jsx';
import VendorSignUp from './Pages/CompanyAdmin/VendorsDetails/VendorApproved/VendorSignUp.jsx';
// import InitialRegistration from './Pages/CompanyAdmin/AdminHome/InitialRegistrion.jsx';
import InitialRegistration from './Pages/CompanyAdmin/AdminHome/InitialRegistration.jsx';
import SurveyorMaster from './Pages/CompanyAdmin/Surveyor/SurveyorMaster.jsx';
import SurveyorApproved from './Pages/CompanyAdmin/Surveyor/SurveyorApproved.jsx';
import MovingVehicles from './Component/CompanyAdmin/Location1/MovingVehicles.jsx';
import CraneDriverHome from './Pages/Vendors/VendorDriver/CraneDriverHome.jsx';
import RidePopUp from './Pages/Vendors/VendorDriver/RidePopUp.jsx';
import CraneUserProfile from './Pages/Vendors/Crane-user-profile/CraneUserProfile.jsx';
import CraneAllVehicles from './Pages/Vendors/VendorAdmin/CraneAllVehicles.jsx';
import VehicleImagePanel from './Pages/Customers/Registration/VehicleImagePanel.jsx';
import NewFirstPage from './Pages/Customers/FirstPageDesigns/NewFirstPage.jsx';
import VendorByMap from './Pages/CompanyAdmin/VendorsDetails/VendorApproved/VendorByMap.js';
import VendorPerformance from './Pages/CompanyAdmin/VendorsDetails/VendorPerformnce.jsx';
import CustomerPerformance from './Pages/CompanyAdmin/CustomersDetails/CustomerApporoved/CustomerPerformance.jsx';
import WorkshopVendorRegistrationForm from './Pages/Vendors/WorkshopVendorRegisterationForm/WorkshopVendorRegisterationForm.jsx';
import { WebSocketProvider } from "./context/WebSocketContext.jsx";
import { LocationProvider } from "./context/LocationContext";


import SignUp from './Pages/Authentication/Registrations/SignUp2.jsx'

import NewContactUs from './Pages/Home/ContactUs/NewContactUs.jsx'
import ContactUs from './Pages/Home/ContactUs/ContactUs.jsx';
import AddVehicles from './Pages/Customers/Registration/AddVehicles.jsx';
import ScrollToTop from './Component/ScrollToTop.jsx';
import Navbar from './Component/Home/Navbar.jsx';
import Footer from './Component/Home/footer/Footer.jsx'
import AddNewVehicleOld from './Pages/Customers/Registration/AddNewVehicleOld.jsx';
import HistoryReceipts from './Pages/Customers/VendorResponsesCustomer/HistoryReceipts.jsx';
import HistoryReceiptss from './Pages/Customers/VendorResponsesCustomer/HistoryReceipts copy.jsx';
import AllCancelledOrders from './Pages/Customers/VendorResponsesCustomer/AllCancelledOrders.jsx';
import CraneOrdersNew from './Pages/Vendors/VendorAdmin/CraneOrders/CraneOrdersNew.jsx';
import LoginPageClient from './Pages/Authentication/Login/LoginPageClient.jsx';
import SubmitImages from './Pages/Authentication/Login/SubmitImages.jsx';

import SubmitImagesCompanyAdmin from './Component/CompanyAdmin/SubmitImagesCompanyAdmin.jsx'
import ViewAndApproveVendor from './Component/CompanyAdmin/ViewAndApproveVendor.jsx';
import NewVendorApproved from './Component/CompanyAdmin/NewVendorApprove.jsx';
import ContactingServicesCard from './Pages/Customers/Registration/ContactingServiceCard.jsx';
import CustomerHome from './Pages/Customers/CustomerHome/CustomerHome.jsx';
import HomeCustomer from './Pages/Customers/CustomerHome/HomeCustomer.jsx';

// import SelectPickupOnMap from './Pages/Customers/Registration/SelectPickupOnMap.jsx';
import SelectOnMap from './Component/Customers/Registration/SelectOnMap.jsx';
import LanguageSelectionPage from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/LanguageSelectionPage.jsx';
import SelectLocationToWork from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/SelectLocationToWork.jsx';
import StateSelector from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/StateSelector.jsx';
import AddVehiclesVendorMaster from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/AddVehiclesVendorMaster.jsx';
import AllAddedVehicles from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/AllAddedVehicles.jsx';
import HistoryDriverPage from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/HistoryDrivePage.jsx';
import SearchForLocation from './Pages/Customers/CustomerHome/SearchForLocation.jsx';
import VendorStatusTracking from './Pages/Customers/VendorResponsesCustomer/VendorStatusTracking.jsx';
import SuccessMessage from './Pages/Customers/VendorResponsesCustomer/SuccessMessage.jsx';
import CurrentWorkingCase from './Pages/Vendors/VendorDriver/CurrentWorkingCase.jsx';
import { ModalProvider, useModal } from './context/ModalContext.jsx';
import ModalBox from './Component/ModalBox/ModalBox.jsx';
import DummyMapFromOLA from './Component/Customers/DummyMapFromOLA.jsx';
import PrivacyPolicy from './Pages/CompanyAdmin/VendorsDetails/PrivacyPolicy.jsx';
import AllServices from './Pages/Customers/CustomerHome/AllServices.jsx';
import ActivityPage from './Pages/Customers/CustomerHome/ActivityPage.jsx';
import VendorDashboard from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/VendorDashboard.jsx';

import VendorDriverHome from './Pages/Vendors/VendorDriver/VendorDriverHome.jsx';
import UserProfileSection from './Pages/Customers/CustomerHome/UserProfileSection.jsx';
import CustomerInvoices from './Pages/Customers/CustomerHome/CustomerInvoices.jsx';
import InspectionReportsList from './Pages/Customers/InspectionReports/InspectionReportsList.jsx';
import InspectionReportView from './Pages/Customers/InspectionReports/InspectionReportView.jsx';
import AdminInspectionReports from './Pages/CompanyAdmin/InspectionReports/AdminInspectionReports.jsx';
import TDSApplicationPage from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/TDSApplicationPage.jsx';
import DriverStatusTracking from './Pages/Customers/VendorResponsesCustomer/DriverStatusTracking.jsx';
import MapWithRoute from './Component/Customers/MapWithRoute.jsx';
import RatingModal from './Pages/Customers/VendorResponsesCustomer/RatingModal.jsx';
import ModalButton from './Pages/Customers/FirstPageDesigns/ModalButton.jsx';
import AuthGuard from './Auth/authGuard.jsx';
import CurrentOrdersList from './Pages/Customers/VendorResponsesCustomer/CurrentOrdersList.jsx';
import AllAddedVehiclesNew from './Pages/Vendors/VendorAdmin/CraneOrders/AllAddedVehiclesNew.jsx';
import AddNewVehicleDetails from './Pages/Vendors/VendorAdmin/CraneOrders/AddNewVehicleDetails.jsx';
import ServiceShowPage from './Pages/Customers/CustomerHome/ServicesShowPage.jsx';
import VendorPaymentStatusTabs from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/VendorPaymentStatusTabs.jsx';
import PaymentFailure from './Pages/Customers/PaymentPage/PaymentFailure.jsx';
import PaymentSuccess from './Pages/Customers/PaymentPage/PaymentSuccess.jsx';
import ViewDetails from './Component/ViewDetails.jsx';
import OLAMapsForDriverLocation from './Component/Customers/OLAMapsForDriverLocation.jsx';
import DeleteAccountPage from './Pages/CompanyAdmin/VendorsDetails/DeleteAccountPage.jsx';
import LocationTracker from './LocationTracker/LocationTracker.jsx';
import TermsConditions from './Pages/CompanyAdmin/VendorsDetails/TermsCondition.jsx';
import SelectPaymentGateway from './Pages/Customers/PaymentPage/SelectPaymentGateway.jsx';
// import FirstTimeLoginPage from './Pages/Authentication/Login/FirstTimeLoginScreen/FirstTimeLoginPage.jsx';
import FirstTimeLoginPage from './Pages/Authentication/Login/FirstTimeLoginScreen/FirstTimeLoginScreen.jsx';
import IncomeEstimationPage from './Pages/Authentication/Login/FirstTimeLoginScreen/IncomeEstimationPage.jsx';
import CancellationRefundPolicy from './Pages/CompanyAdmin/VendorsDetails/CancellationRefundPolicy.jsx';
import ViewVehicleJourneyInfo from './Pages/CompanyAdmin/ViewVehicleInfo/ViewVehicleJourneyInfo.jsx';
import { LoaderProvider } from './context/LoaderContext.jsx';
import Loader from './Component/Loader.js';
import ZohoTest from './Component/ZohoTest.jsx';
import RequestHelp from './Pages/Home/RequestHelp.jsx'
import ReadBlog from './Pages/Home/Blogs/ReadBlog.jsx';
import GeneralInspectionPage from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/GeneralInspection/GeneralInspectionPage.jsx';
import FleetDashboard from './Pages/FleetTracking/FleetDashboard.jsx';
import FleetList from './Pages/FleetTracking/FleetList.jsx';
import WorkshopDashboard from './Pages/CompanyAdmin/VendorResponse/WorkshopDashboard.jsx';
import WorkshopForm from './Pages/Customers/WorkshopDashboard/WorkshopForm.jsx';
// import TyreForm from './Pages/CompanyAdmin/VendorsDetails/VenderMaster/GeneralInspection/TyreForm.jsx';
// import WorkshopAdminDashboard from './Pages/Workshop/WorkshopAdminDashboard.jsx';
// import AdminDashboard from './Pages/Workshop/AdminDashboard.jsx';

import QueryProvider from './context/QueryProvider.jsx';
//Admin-workshop-dashboard
import CasesPage from './Pages/AdminWorkshopPanel/Cases/CasesPage.jsx';
import Dashboard from './Component/Workshop/Dashboard/Dashboard.jsx'
import CaseDetailPage from './Pages/AdminWorkshopPanel/Cases/CaseDetailPage.jsx';
import WorkshopAdminDashboard from './Pages/AdminWorkshopPanel/Layout/WorkshopAdminDashboard.jsx';
import Documents from './Pages/AdminWorkshopPanel/Documents/Documents.jsx';
import WorkshopsPage from './Pages/AdminWorkshopPanel/WorkShops/WorkshopsPage.jsx';
import SurveyorsPage from './Pages/AdminWorkshopPanel/Surveyors/SurveyorsPage.jsx';
import ClaimsPage from './Pages/AdminWorkshopPanel/ClaimsAndPayments/ClaimsPage.jsx';
import ReportsPage from './Pages/AdminWorkshopPanel/Reports/ReportsPage.jsx';
import Fastag from './Pages/Fastag/Fastag.jsx';
import FastagStateDashboard from './Pages/Fastag/FastagStateDashboard.jsx';
import VehicleRegistration from './Pages/CompanyAdmin/AdminHome/VehicleRegistration.jsx';
import RegisteredVehicles from './Pages/CompanyAdmin/AdminHome/RegisteredVehicles.jsx';
import QuickServicesPage from './Pages/AdminWorkshopPanel/QuickServices/QuickServicesPage.jsx';
import QuickServiceDetailPage from './Pages/AdminWorkshopPanel/QuickServices/QuickServiceDetailPage.jsx';
import VendorsPage from './Pages/AdminWorkshopPanel/Vendors/VendorsPage.jsx';
import MarketingPage from './Pages/AdminWorkshopPanel/Marketing/MarketingPage.jsx';
import ChatbotPage from './Pages/AdminWorkshopPanel/Chatbot/ChatbotPage.jsx';
import AdvocateCaseDetailPage from './Pages/AdminWorkshopPanel/QuickServices/Legal/AdvocateCaseDetailPage.jsx';
function App() {

  const userId = localStorage.getItem("userId");
  const isAdmin = userId?.startsWith("EMPID-");
  // console.log(userId);
  return (
    // <div className='root-container'>
    <Provider store={store}>
      <QueryProvider>
      <ModalProvider>
        <WebSocketProvider>
          <LocationProvider>
            <Router>
              <LoaderProvider>
                <Loader />
                <ScrollToTop />
                <ToastContainer />

                {userId && <LocationTracker userId={userId} />}
                <Routes>
                  {/* <Route path="/customer-home-page" element={<HomeCustomer />} /> */}

                  <Route exact path="/" element={<Home />} />
                  <Route path="/Signup" element={<SignUp />} />
                  <Route
                    path="/LoginPageClient"
                    element={<LoginPageClient />}
                  />
                  <Route path="/service-page" element={<ServiceShowPage />} />
                  <Route path='/newContactUs' element={<NewContactUs />} />
                  <Route path='/LoginPage' element={<LoginPage />} />
                  <Route exact path='/privacy-policy' element={<PrivacyPolicy />} />
                  <Route exact path='/terms_&_condition' element={<TermsConditions />} />
                  <Route exact path='/delete-account-page' element={<DeleteAccountPage />} />
                  <Route exact path='/cancellation-refund-policy' element={<CancellationRefundPolicy />} />
                  <Route path='/read-blogs' element={<ReadBlog />} />
                  <Route path='/Blogs' element={<Blogs />} />

                  <Route element={<WorkshopAdminDashboard />}>
                    <Route path="/admin/workshop-dashboard" element={<Dashboard />} />
                    <Route path="/admin/cases" element={<CasesPage />} />
                    <Route path="/admin/cases/:caseId" element={<CaseDetailPage />} />
                    <Route path="/admin/documents" element={<Documents />} />
                    <Route path="/admin/workshops" element={<WorkshopsPage />} />
                    <Route path="/admin/surveyors" element={<SurveyorsPage />} />
                    <Route path="/admin/claims" element={<ClaimsPage />} />
                    <Route path="/admin/reports" element={<ReportsPage />} />
                    <Route path="/admin/quick-services" element={<QuickServicesPage />} />
                    <Route path="/admin/quick-services/:requestCode" element={<QuickServiceDetailPage />} />
                    <Route path = "/admin/quick-services/legal-cases/:caseId" element={<AdvocateCaseDetailPage />} />
                    <Route path="/admin/vendors" element={<VendorsPage />} />
                    <Route path="/admin/marketing" element={<MarketingPage />} />
                    <Route path="/admin/chatbot" element={<ChatbotPage />} />
                  </Route>

                  <Route element={<AuthGuard />}>
                    <Route
                      path="/customer-home-page"
                      element={<CustomerHome />}
                    />

                    <Route exact path='/DummyMapFromOLA' element={<DummyMapFromOLA />} />
                    <Route exact path='/vendor-dashboard' element={<VendorDashboard />} />
                    <Route path="/general-inspection" element={<GeneralInspectionPage />} />
                    <Route path="/customer/workshop-dashboard/:caseId?" element={<WorkshopForm />} />
                    {/* <Route path="//tyre-form/:tyreId" element={<TyreForm />} /> */}
                    <Route
                      path="/user-profile-section"
                      element={<UserProfileSection />}
                    />
                    <Route
                      path="/invoices-for-customers"
                      element={<CustomerInvoices />}
                    />
                    <Route
                      path="/inspection-reports"
                      element={<InspectionReportsList />}
                    />
                    <Route
                      path="/inspection-report/:inspectionCode"
                      element={<InspectionReportView />}
                    />
                    <Route
                      path="/admin-inspection-reports"
                      element={<AdminInspectionReports />}
                    />
                    <Route
                      path="/TDS-Application-page"
                      element={<TDSApplicationPage />}
                    />
                    <Route
                      path="/vendor-driver-status-tracking"
                      element={<DriverStatusTracking />}
                    />
                    <Route path="/MapWithRoute" element={<MapWithRoute />} />
                    <Route path="/RatingModal" element={<RatingModal />} />
                    <Route path="/modalbutton" element={<ModalButton />} />
                    <Route
                      path="/submit-images"
                      element={<SubmitImagesCompanyAdmin />}
                    />
                    <Route
                      path="/viewandapproved"
                      element={<ViewAndApproveVendor />}
                    />
                    <Route
                      path="/NewVendorApproved"
                      element={<NewVendorApproved />}
                    />
                    <Route
                      path="/ContactingServicesCard"
                      element={<ContactingServicesCard />}
                    />
                    <Route path="/all-services" element={<AllServices />} />
                    <Route
                      path="/customer-activity"
                      element={<ActivityPage />}
                    />
                    <Route
                      path="/language-selection-page"
                      element={<LanguageSelectionPage />}
                    />
                    <Route
                      path="/selectLocationToWork"
                      element={<SelectLocationToWork />}
                    />
                    <Route path="/state-selector" element={<StateSelector />} />
                    <Route
                      path="/AddVehiclesVendorMaster"
                      element={<AddVehiclesVendorMaster />}
                    />
                    <Route
                      path="/AllAddedVehicles"
                      element={<AllAddedVehicles />}
                    />
                    <Route
                      path="/HistoryDriverPage"
                      element={<HistoryDriverPage />}
                    />
                    <Route
                      path="/SearchForLocation"
                      element={<SearchForLocation />}
                    />
                    <Route
                      path="/driver-status-tracking"
                      element={<VendorStatusTracking />}
                    />
                    <Route
                      path="/SuccessMessage"
                      element={<SuccessMessage />}
                    />
                    <Route
                      path="/currentWorkingCase"
                      element={<CurrentWorkingCase />}
                    />
                    <Route
                      path="/current-order-list"
                      element={<CurrentOrdersList />}
                    />
                    <Route
                      path="/AllAddedVehiclesNew"
                      element={<AllAddedVehiclesNew />}
                    />
                    <Route
                      path="/add-new-vehicle-details"
                      element={<AddNewVehicleDetails />}
                    />
                    <Route
                      path="/vendor-payment-status-tab"
                      element={<VendorPaymentStatusTabs />}
                    />
                    <Route path="/view-details" element={<ViewDetails />} />

                    <Route
                      path="/payment-success"
                      element={<PaymentSuccess />}
                    />
                    <Route
                      path="/payment-failure"
                      element={<PaymentFailure />}
                    />
                    <Route
                      path="/select-payment-gateway"
                      element={<SelectPaymentGateway />}
                    />

                    <Route
                      path="/olamap"
                      element={<OLAMapsForDriverLocation />}
                    />

                    <Route path="/addVehicles/*" element={<AddVehicles />} />
                    <Route
                      path="/Crane-dashboard/*"
                      element={
                        <ProtectedRoute
                          element={<CraneFirstPage />}
                          requiredRole="customer"
                        />
                      }
                    />
                    <Route path="/ContactUs" element={<ContactUs />} />

                    <Route path="/CaseFirstCard" element={<CaseFirstCard />} />
                    <Route path="/SuccessIcon" element={<SuccessIcon />} />
                    <Route path="/ErrorIcon" element={<ErrorIcon />} />
                    <Route path="/FirstPage" element={<FirstPage />} />
                    <Route
                      path="/Admin"
                      element={<ProtectedRoute element={<Admin />} />}
                    />
                    <Route
                      path="/moving-vehicle"
                      element={<ProtectedRoute element={<MovingVehicles />} />}
                    />
                    <Route
                      path="/crane-driver-home"
                      element={<ProtectedRoute element={<CraneDriverHome />} />}
                    />
                    <Route
                      path="/vendor-driver-home"
                      element={
                        <ProtectedRoute element={<VendorDriverHome />} />
                      }
                    />
                    <Route
                      path="/ride-popup"
                      element={<ProtectedRoute element={<RidePopUp />} />}
                    />
                    <Route
                      path="/CompletePayment"
                      element={<CompletePayment />}
                      requiredRole="customer"
                    />
                    <Route
                      path="/User-landing-page"
                      element={
                        <ProtectedRoute
                          element={<NewFirstPage />}
                          requiredRole="customer"
                        />
                      }
                    />
                    <Route
                      path="/all-vehicles-registered"
                      element={
                        <ProtectedRoute
                          element={<AllVehicles />}
                          requiredRole="customer"
                        />
                      }
                    />
                    <Route
                      path="/AllCancelledOrders"
                      element={
                        <ProtectedRoute
                          element={<AllCancelledOrders />}
                          requiredRole="customer"
                        />
                      }
                    />
                    <Route
                      path="/all-accident-vehicles-old"
                      element={
                        <ProtectedRoute
                          element={<AllAccidentVehiclesUser />}
                          requiredRole="customer"
                        />
                      }
                    />
                    <Route
                      path="/all-accident-vehiclesh"
                      element={
                        <ProtectedRoute
                          element={<HistoryReceiptss />}
                          requiredRole="customer"
                        />
                      }
                    />
                    <Route
                      path="/all-accident-vehicles"
                      element={
                        <ProtectedRoute
                          element={<HistoryReceipts />}
                          requiredRole="customer"
                        />
                      }
                    />
                    <Route
                      path="/user-profile"
                      element={
                        <ProtectedRoute
                          element={<UserProfileFirst />}
                          requiredRole="customer"
                        />
                      }
                    />
                    <Route
                      path="/user-profile-details"
                      element={
                        <ProtectedRoute
                          element={<UserProfileDetails />}
                          requiredRole="customer"
                        />
                      }
                    />
                    <Route
                      path="/kyc-documents"
                      element={
                        <ProtectedRoute
                          element={<KycDocuments />}
                          requiredRole="customer"
                        />
                      }
                    />
                    <Route
                      path="/add-new-vehicle-driverOld"
                      element={
                        <ProtectedRoute
                          element={<AddNewVehicleOld />}
                          requiredRole="customer"
                        />
                      }
                    />
                    <Route
                      path="/add-new-vehicle-driver"
                      element={
                        <ProtectedRoute
                          element={<AddNewVehicle />}
                          requiredRole="customer"
                        />
                      }
                    />
                    <Route
                      path="/vehicleimagepanel"
                      element={<VehicleImagePanel />}
                    />
                    <Route
                      path="/crane-user-landing-page"
                      element={
                        <ProtectedRoute
                          element={<CraneUserLanding />}
                          requiredRole="crane"
                        />
                      }
                    />
                    <Route
                      path="/map-vendor-distance"
                      element={
                        <ProtectedRoute element={<MapForVendorDistance />} />
                      }
                    />
                    <Route
                      path="/all-accident-vehicles-history"
                      element={<ProtectedRoute element={<HistoryPageUser />} />}
                    />
                    <Route
                      path="/crane-user-dashboard"
                      element={
                        <ProtectedRoute
                          element={<CraneUserDashboard />}
                          requiredRole="crane"
                        />
                      }
                    />
                    <Route
                      path="/crane-user-all-cases"
                      element={<ProtectedRoute element={<CraneOrders />} />}
                    />
                    <Route
                      path="/crane-user-all-cases-new"
                      element={<ProtectedRoute element={<CraneOrdersNew />} />}
                    />
                    <Route
                      path="/crane-vehicle-information"
                      element={
                        <ProtectedRoute element={<CraneVehicleData />} />
                      }
                    />
                    <Route
                      path="/crane-user-profile"
                      element={
                        <ProtectedRoute element={<CraneUserProfile />} />
                      }
                      requiredRole="crane"
                    />
                    <Route
                      path="/crane-all-vehicles"
                      element={
                        <ProtectedRoute element={<CraneAllVehicles />} />
                      }
                      requiredRole="crane"
                    />
                    <Route path="/UserSideBar" element={<UserSideBar />} />
                    <Route
                      path="/SelectLocationOnMap"
                      element={<SelectLocationOnMap />}
                    />
                    <Route
                      path="/new-vehicle-registration"
                      element={<NewAccidentVehicle />}
                    />
                    <Route
                      path="/ProductDetailsSeller"
                      element={<ProductDetailsSeller />}
                    />
                    <Route
                      path="/SidebarWithSubmenus"
                      element={<SidebarWithSubmenus />}
                    />
                    <Route
                      path="/ProductRegister"
                      element={<ProductRegister />}
                    />
                    <Route path="/Sidebar" element={<Sidebar />} />
                    <Route
                      path="/register-new-accidentvehicle"
                      element={<Registration />}
                    />
                    <Route
                      path="/vendor-form"
                      element={
                        <ProtectedRoute element={<VendorMasterForm />} />
                      }
                    />
                    <Route
                      path="/vendor-view-form"
                      element={<ProtectedRoute element={<VendorApporoved />} />}
                    />
                    <Route path="/vendor-edit" element={<VendorMasterEdit />} />
                    <Route
                      path="/vendor-map-details"
                      element={<VendorByMap />}
                    />
                    <Route
                      path="/vendor-performance-details"
                      element={<VendorPerformance />}
                    />
                    <Route
                      path="/customer-form"
                      element={
                        <ProtectedRoute element={<CustomerMasterForm />} />
                      }
                    />
                    <Route
                      path="/customer-form-edit"
                      element={
                        <ProtectedRoute element={<CustomerMasterEdit />} />
                      }
                    />
                    <Route
                      path="/customer-form-activity"
                      element={
                        <ProtectedRoute element={<CustomerPerformance />} />
                      }
                    />
                    <Route
                      path="/employee-form"
                      element={<ProtectedRoute element={<EmployeeForm />} />}
                    />
                    <Route
                      path="/view-employee"
                      element={
                        <ProtectedRoute element={<EmployeeApproved />} />
                      }
                    />
                    <Route
                      path="/edit-employee"
                      element={
                        <ProtectedRoute element={<EmployeeFormEdit />} />
                      }
                    />
                    <Route
                      path="/vehicle-claim-registration"
                      element={
                        <ProtectedRoute
                          element={<VehicleClaimRegistration />}
                        />
                      }
                    />
                    <Route
                      path="/vehicle-claim-edit"
                      element={
                        <ProtectedRoute element={<VehicleClaimEdit />} />
                      }
                    />
                    <Route
                      path="/Visitors-form"
                      element={<ProtectedRoute element={<Visitors />} />}
                    />
                    <Route
                      path="/customer-enquiry-form"
                      element={<ProtectedRoute element={<CustomerEnquiry />} />}
                    />
                    <Route
                      path="/challan-form"
                      element={<ProtectedRoute element={<Challan />} />}
                    />
                    <Route
                      path = "/fleet-dashboard"
                      element={<ProtectedRoute element={<FleetDashboard />} />}
                    />
                    <Route
                      path = "/fleet-list"
                      element={<ProtectedRoute element={<FleetList />} />}
                    />
                    <Route
                      path = "/fastag-details/:vehicleNumber?"
                      element={<ProtectedRoute element={<Fastag />} />}
                    />
                    <Route
                      path = "/fastag-dashboard"
                      element={<ProtectedRoute element={<FastagStateDashboard />} />}
                    />
                    <Route
                      path="/signup-form-submissions"
                      element={<ProtectedRoute element={<VendorSignUp />} />}
                    />
                    <Route
                      path="/signup-form-view"
                      element={
                        <ProtectedRoute element={<VehicleRegistration />} />
                      }
                    />
                    <Route
                      path="/view-registered-vehicles"
                      element={
                        <ProtectedRoute element={<RegisteredVehicles />} />
                      }
                    />
                    <Route
                      path="/customer-view-form"
                      element={
                        <ProtectedRoute element={<CustomerApproved />} />
                      }
                    />
                    <Route
                      path="/accident-vehicle-register-update"
                      element={
                        <ProtectedRoute
                          element={<AccidentVehicleRegUpdate />}
                        />
                      }
                    />
                    <Route
                      path="/view-vehicle-journey-info"
                      element={
                        <ProtectedRoute element={<ViewVehicleJourneyInfo />} />
                      }
                    />
                    <Route
                      path="/view-accident-vehicle-register-details"
                      element={<ProtectedRoute element={<ViewVehicleInfo />} />}
                    />
                    <Route
                      path="/accident-vehicle"
                      element={<ProtectedRoute element={<AccidentVehicle />} />}
                    />
                    <Route
                      path="/daily-image-upload"
                      element={<ProtectedRoute element={<ImageUpload />} />}
                    />
                    <Route
                      path="/vendor-response"
                      element={<ProtectedRoute element={<VendorResponse />} />}
                    />
                    <Route
                      path="/add-surveyor"
                      element={<ProtectedRoute element={<SurveyorMaster />} />}
                    />
                    <Route
                      path="/view-surveyor"
                      element={
                        <ProtectedRoute element={<SurveyorApproved />} />
                      }
                    />
                    <Route
                      path="/VendorMasterViewOnly"
                      element={
                        <ProtectedRoute element={<VendorMasterViewOnly />} />
                      }
                    />
                    <Route
                      path="/UserDashboard"
                      element={<ProtectedRoute element={<User />} />}
                    />
                    <Route
                      path="/AdvocateDashboard"
                      element={<ProtectedRoute element={<Advocate />} />}
                    />
                    <Route
                      path="/MechanicDashboard"
                      element={<ProtectedRoute element={<Mechanic />} />}
                    />
                    <Route
                      path="/CraneDashboard"
                      element={<ProtectedRoute element={<CraneHydra />} />}
                    />
                    <Route
                      path="/AddedDataByCrane"
                      element={
                        <ProtectedRoute element={<AddedDataByCrane />} />
                      }
                    />
                    <Route
                      path="/WorkshopDashboard"
                      element={<ProtectedRoute element={<Workshop />} />}
                    />
                    <Route
                      path="/DailyWorkshop"
                      element={<ProtectedRoute element={<DailyWorkshop />} />}
                    />
                    <Route path="/Payment/:token" element={<Payment />} />
                    <Route
                      path="/vendor-comission/:token"
                      element={<VendorPayment />}
                    />
                    <Route
                      path="/MechanicDashboard"
                      element={
                        <ProtectedRoute element={<MechanicDashboard />} />
                      }
                    />
                    <Route
                      path="/CreatePassword/:userType"
                      element={<CreatePassword />}
                    />
                    <Route
                      path="/Administration"
                      element={<ProtectedRoute element={<Administration />} />}
                    />
                    <Route
                      path="/Salesteam"
                      element={<ProtectedRoute element={<Salesteam />} />}
                    />
                    <Route path="/Registration" element={<SignUp />} />
                    <Route path="/ImageViewer" element={<ImageViewer />} />
                    <Route path="/ImageDetails" element={<ImageDetails />} />
                    <Route
                      path="/admin-dashboard-vendor-customer"
                      element={
                        <ProtectedRoute
                          element={<DummyDashboard />}
                          requiredRole={["Management", "IT"]}
                        />
                      }
                    />

                    <Route
                      path="/welcome-page"
                      element={<FirstTimeLoginPage />}
                    />
                    <Route
                      path="/estimated-earnings"
                      element={<IncomeEstimationPage />}
                    />
                  </Route>
                  <Route path='/get-help' element={<RequestHelp />} />

                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </LoaderProvider>
            </Router>
          </LocationProvider>
        </WebSocketProvider>
        <GlobalModal />
      </ModalProvider>
      </QueryProvider>  
    </Provider>
    // </div>
  );
}

const GlobalModal = () => {
  const { modalData, closeModal } = useModal();
  return (
    <ModalBox
      isOpen={modalData.isOpen}
      title={modalData.title}
      body={modalData.body}
      iconType={modalData.iconType}
      onClose={closeModal}
      onAction={modalData.onAction}
      actionLabel={modalData.actionLabel}
    />
  );
};

export default App;